import MultiStepForm from "@/pages/articles-pages/programmes/MultiStepForm/MultiStepForm"

const CreateAndEditProgramme = () => {
  return (
    <div>
      <MultiStepForm />
    </div>
  )
}

export default CreateAndEditProgramme